import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import store from './store'
import './i18n' // Initialize i18n
import 'bootstrap/dist/css/bootstrap.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import './index.css'
import App from './App.jsx'

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <App />
  </Provider>,
)
